
export function setConfig(config) {
  return {
    type: 'SET_CONFIG',
    payload: config
  }
}